import script from "./InfoSection.vue?vue&type=script&setup=true&lang=ts"
export * from "./InfoSection.vue?vue&type=script&setup=true&lang=ts"

import "./InfoSection.vue?vue&type=style&index=0&id=b4c2b39c&lang=css"

const __exports__ = script;

export default __exports__